import PricingTier from "../PricingTier";

describe("PricingTier model", () => {
  test("belongsTo relations", () => {
    expect(
      PricingTier.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
